// extracted by mini-css-extract-plugin
module.exports = {"filter_wrapper":"FilterWrapper_filter_wrapper__24rAT"};